import { render, staticRenderFns } from "./survey-periodical-select.vue?vue&type=template&id=b921c0c0"
import script from "./survey-periodical-select.vue?vue&type=script&lang=js"
export * from "./survey-periodical-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports